import StatusDot from './StatusDot';
import StatusDotBeta from './variations/StatusDotBeta';
import StatusDotError from './variations/StatusDotError';
import StatusDotInformation from './variations/StatusDotInformation';
import StatusDotSuccess from './variations/StatusDotSuccess';
import StatusDotWarning from './variations/StatusDotWarning';

export {
	StatusDot,
	StatusDotBeta,
	StatusDotError,
	StatusDotInformation,
	StatusDotSuccess,
	StatusDotWarning,
};
